import React from "react";

const PeopleMetricIcon = () => {
  return (
    <svg width="24" height="17" viewBox="0 0 24 17" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill="none">
        <path
          d="M7 1c-.3380331.0043894-.6741077.05211198-1 .142C7.7646282 1.59057524 8.99998165 3.1792495 8.99998165 5S7.7646282 8.40942476 6 8.858c.3258923.08988802.6619669.1376106 1 .142 2.20913898-e-8 3.9999999-1.79086102 3.9999999-4S9.20913898 1.00000003 7 1z"
          className="icon icon__shade"
        />
        <path
          d="M9.3207 9.4038c2.0382607-1.0680504 3.0843656-3.38933634 2.5344028-5.6237891C11.30514 1.5455581 9.30113848-.02500928 7-.02500928S2.69486003 1.5455581 2.1448972 3.7800109C1.59493438 6.01446365 2.64103932 8.3357496 4.6793 9.4038 1.8338799 10.6123166-.01000735 13.4085881 0 16.5c0 .2761424.22385763.5.5.5.27614238 0 .5-.2238576.5-.5C1 13.1914 3.6914 10 7 10s6 3.1914 6 6.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c.0100074-3.0914119-1.8338799-5.8876834-4.6793-7.0962zM3 5c0-2.209139 1.790861-4 4-4s4 1.790861 4 4-1.790861 4-4 4c-2.20808814-.00253493-3.99746507-1.79191186-4-4z"
          className="icon icon__line"
        />
        <path
          d="M19.64 7.3694c1.5044965-.95237362 2.1983247-2.78456633 1.7020507-4.49460648-.4962741-1.71004014-2.0631477-2.8861502-3.8437443-2.8851506-1.7805966.00099962-3.3461487 1.1788682-3.8405024 2.88946447-.4943538 1.71059626.2015311 3.5420088 1.707096 4.4926926-1.3192749.45949902-2.4562826 1.33021874-3.2438 2.4841.2603097.2201984.5064029.4566723.7368.708 1.3058727-2.07056892 3.8240114-3.02751072 6.1754301-2.3467838C21.3847488 8.8978431 23.0022273 11.0520306 23 13.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c-.0047608-2.7618179-1.7527359-5.2196473-4.36-6.1306zM14.5 4c0-1.65685425 1.3431458-3 3-3s3 1.34314575 3 3-1.3431458 3-3 3c-1.6560775-.0018737-2.9981263-1.3439225-3-3z"
          className="icon icon__line"
        />
        <path
          d="M17.5 1c-.341459.0033925-.6797659.06574247-1 .1843 1.1976858.41766735 2.0000848 1.54727683 2.0000848 2.8157 0 1.26842317-.802399 2.39803265-2.0000848 2.8157.3202341.11855753.658541.1809075 1 .1843 1.6568542 0 3-1.34314575 3-3s-1.3431458-3-3-3z"
          className="icon icon__shade"
        />
      </g>
    </svg>
  );
};
export default PeopleMetricIcon;
